import { render, staticRenderFns } from "./SectionMenuMarket.vue?vue&type=template&id=3d21edb0&scoped=true&"
import script from "./SectionMenuMarket.vue?vue&type=script&lang=js&"
export * from "./SectionMenuMarket.vue?vue&type=script&lang=js&"
import style0 from "./SectionMenuMarket.vue?vue&type=style&index=0&id=3d21edb0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d21edb0",
  null
  
)

export default component.exports